import { CollectionFavoriteStateChannel } from '@tableau/search-microview-communication-channels';

export class CollectionFavoriteStateService {
  public static instance = new CollectionFavoriteStateService();

  public getCollectionFavoriteState(id: string): Promise<boolean> {
    const collectionFavoriteStateChannel = new CollectionFavoriteStateChannel();
    return collectionFavoriteStateChannel.call({ id }).data || Promise.reject();
  }
}
